import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamPLL() {
  return (
    <div className={styles["declaration"]}>
      <h1>Oświadczenie o zgodności dotyczące szkolenia i egzaminów dla pracowników terenowych</h1>

      <p>
        Aby nieustannie podnosić jakość usług świadczonych przez zewnętrznych promotorów na pierwszej linii, Międzynarodowy zespół Xiaomi ds. szkoleń (określany dalej jako „my” lub „nasza firma”) zapewnia kursy szkoleniowe i towarzyszące im egzaminy uzupełniające wiedzę dla zewnętrznych promotorów (określanych dalej jako „stażyści”) wyznaczonych przez dostawców usług outsourcingowych. Celem szkolenia i egzaminu jest optymalizacja treści kursu oraz utrwalenie wyników nauczania. Nie stanowią one żadnej formy stosunku pracy ani faktycznego działania kadry zarządzającej. Poniżej znajduje się oświadczenie dotyczące szkolenia i egzaminu:
      </p>

      <ol>
        <li>
          <strong>Charakter szkolenia i egzaminu</strong><br/>
          Wszystkie szkolenia i egzaminy są przeprowadzane w celu dzielenia się wiedzą, aby ułatwić uczestnikom systematyczne zrozumienie informacji o produktach i standardach usług itp. Wyniki egzaminów odzwierciedlają jedynie stopień przyswojenia treści szkolenia przez uczestników i nie stanowią podstawy oceny wyników. Nie mamy uprawnień i nie będziemy ingerować w ocenę wyników dostawców usług outsourcingowych, podział wynagrodzeń ani inne kwestie związane z zatrudnieniem uczestników.
        </li>
        <li>
          <strong>Wyjaśnienie stosunku prawnego</strong><br/>
          Niniejszy program szkolenia i egzaminowania nie wpływa na stosunki pracodawca-pracownik, pomiędzy stażystami i ich dostawcami usług outsourcingowych. W odniesieniu do naszej firmy i stażystów nie istnieje żaden stosunek pracy pomiędzy pracodawcą a pracownikiem, a niniejszy program szkolenia i egzaminowania, mający na celu dzielenie się wiedzą, nie ustanawia żadnego faktycznego stosunku pracy ze stażystami. Wszelkie prawa i obowiązki wynikające z zatrudnienia obowiązują wyłącznie między dostawcami usług outsourcingowych a stażystami.
        </li>
        <li>
          <strong>Wykorzystanie wyników egzaminów</strong><br/>
          Wyniki egzaminów będą wykorzystywane wyłącznie w następujących celach:
          <ol type="1">
            <li>Jako źródło informacji dotyczących optymalizacji i doskonalenia wewnętrznych kursów naszej firmy;</li>
            <li>Dla dostawców usług outsourcingowych stanowią dowód kompetencji zawodowych stażystów; podlegają niezależnej ocenie i woli dostawców usług outsourcingowych;</li>
            <li>Wyniki egzaminów nie będą upubliczniane ani ujawniane osobom trzecim.</li>
          </ol>
        </li>
      </ol>

      <p>
        Niniejsze oświadczenie wchodzi w życie z dniem publikacji. Udział w programie szkolenia i egzaminowania oznacza, że uczestnicy szkolenia zapoznali się z niniejszym oświadczeniem i je akceptują. Nasza firma zastrzega sobie prawo do interpretacji i może, w uzasadnionym zakresie, zmieniać to oświadczenie w dowolnym momencie, pod warunkiem, że zmiany te nie będą miały wpływu na szkolenie i egzamin, które nie mają charakteru zatrudnienia. W przypadku jakichkolwiek sporów lub rozbieżności pomiędzy różnymi wersjami językowymi obowiązuje wersja w języku angielskim.
      </p>

      <div className={styles["footer"]}>
        Międzynarodowy zespół Xiaomi ds. szkoleń<br/>
        Data: {getLocalizedTime('pl-PL')}
      </div>
    </div>
  );
}